// Import Swiper and required modules
import Swiper from "swiper";
import { Pagination, Navigation, A11y } from "swiper/modules";

const quoteSlider = () => {
	// Initialize Swiper
	const swiper = new Swiper("#slider", {
		modules: [Navigation, Pagination, A11y], // Add required modules
		slidesPerView: 1, // Show one slide at a time
		spaceBetween: 30, // Space between each slide
		navigation: {
			nextEl: ".slider-arrow--next",
			prevEl: ".slider-arrow--prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: false
		},
	});
};
export default quoteSlider;
